module.exports = __webpack_public_path__ + "static/media/ren_default8dd0de3d7072970831b8d955df18f64a.webp";